import { render, staticRenderFns } from "./SolarWidget.vue?vue&type=template&id=abd24c2a&scoped=true&"
import script from "./SolarWidget.vue?vue&type=script&lang=js&"
export * from "./SolarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd24c2a",
  null
  
)

export default component.exports